import type { FindFn } from "@shared/models/analytics/base"
import type { Course } from "@shared/models/course"
import { get } from "lodash-es"

interface Payload {
  course?: Course
  courseId?: string
}

export default function (payload: Payload, findFn: FindFn, userId: string) {
  // Terrible ternary. if course, use course, otherwise, look it up, otherwise, null
  let course = payload.course
    ? payload.course
    : payload.courseId
    ? findFn("course", payload.courseId)
    : null
  let planbook = course
    ? findFn("planbook", get(course, "relationships.planbook.data.id") as string)
    : null
  let user = findFn("user", userId)

  return {
    course,
    planbook,
    user,
  }
}
